import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RomanticCompatibilityReport from "./component";
import {
  getInsightfulContent,
  getUserAssessmentResultByResultId,
  sendToFriendReportOnEmail,
} from "../dashboard/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInsightfulContentConnect: getInsightfulContent,
      getUserAssessmentResultByResultIdConnect:
        getUserAssessmentResultByResultId,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RomanticCompatibilityReport);
